import React, {useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import { Space } from 'antd'
import {fillZero} from "../util/util";
import Icon from "./Icon";

export default (prop) => {

    const {t} = useTranslation()

    const hero = {...prop.hero}

    if (typeof hero.abilitySet === 'string') {

        hero.abilitySet = hero.abilitySet.split(' ')
        hero.abilityUpSeq = hero.abilityUpSeq.split(' ')
        hero.initStats = hero.initStats.split(' ')
        hero.primaryRunes = hero.primaryRunes.split(' ')
        hero.spells = hero.spells.split(' ')
        hero.statSet = hero.statSet.split(' ')

        let temp = []
        hero.initStats.forEach((stat, index) => {
            for (let i = 0; i < stat; i++) {
                temp.push([4, 6, 0, 1, 2, 3][index])
            }
        })
        hero.initStats = temp
        hero.abilityMap = new Map()
        hero.abilitySet.forEach((ability, index) => {
            hero.abilityMap.set(index, ability)
        })
        temp = []
        hero.statSet.forEach((num, stat) => {
            if (stat != 8 && stat != 9) {
                temp.push({
                    stat,
                    num,
                })
            }
        })
        hero.statSet = temp
    }


    const getAbilityName = (row, column) => {
        return `${fillZero(hero.heroId)}_${Number(row) + 1}_${column}${['t','q','w','e','r'][column]}`
    }
    const getAbilityName2 = (column) => {
        return getAbilityName(hero.abilityMap.get(Number(column)), column)
    }
    const getSpellName = (row, column) => {
        return `${Number(column)}_${row}`
    }

    useEffect(() => {

    }, [])

    return <div style={{padding: '12px', fontSize: "18px"}}>
        <Space direction={'vertical'}>
            {
                hero.exit == 1 && <span style={{color: 'red'}}>{`${t('escapeTime')}${Math.floor(hero.exitFrame / 16 / 60 / 1.4)}:${fillZero(Math.floor(hero.exitFrame / 16 / 1.4) % 60)}`}</span> || null
            }
            <Space>
                {hero.abilitySet.map((row, i) => <Icon key={getAbilityName(row, i)} name={getAbilityName(row, i)} type={'ability'} size={30}/>)}
                {hero.spells.map((row, i) => <Icon key={getSpellName(row, i)} name={getSpellName(row, i)} type={'spell'} size={30}/>)}
                <div>
                    {`${t('playerHandle')}${hero.playerHandle}`}
                </div>
            </Space>
            <Space>
                {hero.initStats.map((stat, i) => <Icon key={`${i}`} name={`${stat}`} type={'stat'} size={30}/>)}
            </Space>
            <Space>
                {hero.primaryRunes.map((rune) => <Icon key={`${hero.primaryColumn}_${rune}`} name={`${hero.primaryColumn}_${rune}`} type={'rune'} size={30}/>)}
                <Icon name={`${hero.secondaryColumn}_${hero.secondaryRune}`} type={'rune'} size={30}/>
            </Space>
            <Space>
                {hero.abilityUpSeq.filter(r => r != -1).map((row, i) => <Icon key={i} name={getAbilityName2(row, i)} type={'ability'} size={30}/>)}
            </Space>
            <Space>
                {hero.statSet.map(({num, stat}) => {

                    return <div style={{position: "relative"}} key={stat}>
                        <Icon name={stat} type={'stat'} size={44}/>
                        <b style={{fontSize: "22px", position: "absolute", left: 0, top: -6, color: "#faad14"}}>{num}</b>
                    </div>
                })}
            </Space>
        </Space>
    </div>
}
